import React, { useState } from "react";
import { ArrowRight, Link2, PenLine } from "lucide-react";
import "./CreateWantListingStart.scss";

const Option = ({ icon: Icon, title, body, onClick, primary, children, busy }) => (
  <div className={`create-start__option${primary ? " is-primary" : ""}`}>
    <button type="button" className="create-start__hit" onClick={onClick} disabled={busy}>
      <span className="create-start__icon" aria-hidden="true">
        <Icon size={20} />
      </span>
      <span className="create-start__copy">
        <span className="create-start__title">{title}</span>
        <span className="create-start__body">{body}</span>
      </span>
      <ArrowRight className="create-start__arrow" size={18} aria-hidden="true" />
    </button>
    {children}
  </div>
);

const DRAFTS_SHOWN = 3;

const Drafts = ({ drafts }) => {
  const [all, setAll] = useState(false);
  const list = React.Children.toArray(drafts);
  if (!list.length) return null;
  const extra = list.length - DRAFTS_SHOWN;
  return (
    <section className="create-start__drafts" aria-label="Your drafts">
      <h2 className="create-start__subheading">Pick up a draft</h2>
      {all ? list : list.slice(0, DRAFTS_SHOWN)}
      {extra > 0 ? (
        <button type="button" className="create-start__pro-link create-start__more" onClick={() => setAll(!all)}>
          {all ? "Show fewer drafts" : `Show all drafts (${list.length})`}
        </button>
      ) : null}
    </section>
  );
};

const CreateWantListingStart = ({
  networkName,
  showBuyerForm,
  isPro,
  onCreate,
  onSendForm,
  onTryPro,
  sendingForm,
  drafts,
}) => (
  <div className="create-start">
    <h1 className="create-start__heading">Post a Buyer Want&#8209;Listing</h1>
    <p className="create-start__lede">
      Every {networkName} member sees it, and listing agents with a matching home reach you&nbsp;directly.
    </p>

    <div className="create-start__options">
      <Option
        primary
        icon={PenLine}
        title="Write it yourself"
        body="Where, price, beds and baths, then publish to the network."
        onClick={onCreate}
      />
      {showBuyerForm ? (
        <Option
          icon={Link2}
          title="Have your buyer fill it in"
          body={"Send your buyer a link. They add what they want, then you review and publish it. Buying\u00a0only."}
          onClick={isPro ? onSendForm : onTryPro}
          busy={sendingForm}
        >
          {!isPro ? (
            <p className="create-start__pro">
              Included with Gitcha Pro.{" "}
              <button type="button" className="create-start__pro-link" onClick={onTryPro}>
                Try Gitcha&nbsp;Pro
              </button>
            </p>
          ) : null}
        </Option>
      ) : null}
    </div>

    {drafts ? <Drafts drafts={drafts} /> : null}
  </div>
);

export default CreateWantListingStart;
